export const COPYRIGHT_HOLDER = "SageSure";
export const TERMS_OF_SERVICE_URL =
  "https://www.sagesure.com/terms-and-conditions/";
export const PRIVACY_POLICY_URL = "https://www.sagesure.com/privacy-policy/";
export const SUPPORT_URL = "https://www.sagesure.com/support/";
